import { render, staticRenderFns } from "./worker.vue?vue&type=template&id=0cdd1ce4&scoped=true&"
import script from "./worker.vue?vue&type=script&lang=js&"
export * from "./worker.vue?vue&type=script&lang=js&"
import style0 from "./worker.vue?vue&type=style&index=0&id=0cdd1ce4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdd1ce4",
  null
  
)

export default component.exports